// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"885":"0e45f6a6","960":"0ea334fd"}[chunkId] + ".chunk.js";
};